export const REALDB_CONSTANT = {
  Sellersdata: "/premiere_2026_nesco/Sellersdata",
  SellerBaseData: "/premiere_2026_nesco/SellerBaseData",
};
